import React from 'react';
import styled from 'styled-components';

export const WIDTH_PRIMIS_AD = 300;
export const WIDTH_PRIMIS_AD_WIDE = 338;

const Root = styled.div<{ width: number; height: number }>`
    width: ${props => props.width}px;
    height: ${props => props.height}px;
`;

export const AdsPrimisNormal: React.FC = () => {
    return <Root height={553} id="ad-primis-normal" width={WIDTH_PRIMIS_AD} />;
};

export const AdsPrimisWide: React.FC = () => {
    return <Root height={600} id="ad-primis-wide" width={WIDTH_PRIMIS_AD_WIDE} />;
};
